module.exports = __webpack_public_path__ + "img/main-bg.35ce35a3.png";